module.exports = __webpack_public_path__ + "img/40_38_085_810.6f743397.jpg";